<template>
    <div class="bg-white p-4" style="border: solid 1px #eaeaea">
      <ValidationObserver tag="form" ref="form" @submit.stop.prevent="savePart" v-slot="{ invalid }" class="">
        <div class="row">
          <div class="col-12">
            <ValidationProvider name="Status" rules="" v-slot="{  }">
              <div class="label mt-2">Status</div>
              <select class="form-control" v-model="vendorRequestPart.requestStatusId">
                <option v-for="status in requestStatus" :value="status.id" :key="status.id">{{status.name}}</option>
              </select>
            </ValidationProvider>
          </div>
        </div>

        <div class="row">
          <div class="col-6">
            <ValidationProvider name="Quantity" rules="" v-slot="{ errors }">
              <div class="label mt-2">Quantity Available</div>
              <input
                type="number"
                class="form-control"
                placeholder="Quantity available"
                :class="{ 'is-invalid': errors[0] }"
                v-model="vendorRequestPart.quantityAvailable"
              />
            </ValidationProvider>
          </div>

          <div class="col-6">
            <ValidationProvider name="Quantity" rules="" v-slot="{ errors }">
              <div class="label mt-2">Price / Unit</div>
              <div class="d-flex">
              <input
                type="text"
                class="form-control"
                placeholder="Price"
                :class="{ 'is-invalid': errors[0] }"
                v-model="vendorRequestPart.pricePerUnit"
              />
              <select class="form-control ml-2" v-model="vendorRequestPart.currency">
                <option :value="null">N/A</option>
                <option :value="'EUR'">EUR</option>
                <option :value="'USD'">USD</option>
              </select>
              </div>
            </ValidationProvider>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="label mt-2">Location</div>
            <input type="text" class="form-control" placeholder="Location of the part" v-model="vendorRequestPart.location" />
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <ValidationProvider name="DateAvailable" rules="" v-slot="{}">
              <div class="label mt-2">Available Time</div>
              <board-item-date-picker v-model="vendorRequestPart.dateAvailable"></board-item-date-picker>
            </ValidationProvider>
          </div>
        </div>

        <hr />

        <div class="mt-3 d-flex justify-content-between align-content-center">
          <div class="so-btn">
            <button type="button" class="btn btn-block btn-sm btn-secondary" @click="close()">
              <i class="far fa-times"></i>
              Close
            </button>
          </div>
          <div class="d-flex">
          <div class="so-btn">
            <button type="submit" class="btn btn-block btn-sm btn-success" :disabled="invalid">
              <i class="far fa-save"></i>
              Save and close
            </button>
          </div>
          </div>
        </div>
      </ValidationObserver>
    </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import { materialRequestClient } from '@/apiclient/opsboardapi';
  import { RequestStatusDto, VendorRequestPartEditDto } from "@/apiclient/apiclient_generated";
  import { GlobalHelper } from '@/helpers/global-helper';

  @Component({
    components: {},
  })
  export default class EditVendorRequestPartRequest extends Vue {
    materialRequestId: string;
    vendorRequestPartId: string;
    vendorRequestPart: VendorRequestPartEditDto = VendorRequestPartEditDto.fromJS({part: {pn: ''}});

    requestStatus: RequestStatusDto[] =[];

    created() {
      this.materialRequestId = this.$router.currentRoute.params.materialRequestId;
      this.vendorRequestPartId = this.$router.currentRoute.params.vendorRequestPartId;
    }

    async mounted() {
      await this.loadData();
    }

    async loadData() {
      this.vendorRequestPart = await materialRequestClient.getVendorRequestPartEditDto(this.vendorRequestPartId);
      this.requestStatus = await materialRequestClient.getRequestStatus();
      await this.$nextTick();
      (this.$refs.form as any).validate();
    }

    async savePart() {
      try {
        await materialRequestClient.editVendorRequestPart(this.vendorRequestPart);
        GlobalHelper.NotifySuccess('Part saved');
        this.$emit('saved');
      } catch {
        GlobalHelper.NotifyError('Error occured');
      }
    }

    close() {
      this.$emit('close');
    }
  }
</script>

<style lang="scss" scoped></style>
